import React, { useEffect, useMemo, useState } from "react";
import jwt_decode from "jwt-decode";
import AxiosLibWithHeader2 from "../../../../../../Library/AxiosLibWithHeader2";
import { openToast } from "../../../../../../Library/ToastPopUp";
import { openModal } from "../../../../../../Library/ModalPopUp";
import PreviewPCFRevision from "../WPreviewPCF/PreviewPCFRevision";
import PreviewTimetables from "../timetables-draft/PreviewTimetables";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export default function MyPCFRevisions({
  student,
  stdStatus,
  fPCF,
  mypcf,
  originPCFRev,
  setMypcf,
  eventid,
  studentid,
  acad,
  totalsks,
  setTotalSKS,
  selectedAcad,
}) {
  const tmpl_dt = student?.tmpl_hd?.tmpl_dt || [];
  const tmpl_max_credit =
    tmpl_dt.find((item) => item.key_id === "key.asc.rereg.pcf.maxcredit")
      ?.value || 24;
  const tmpl_check_amount =
    tmpl_dt.find((item) => item.key_id === "key.asc.rereg.pcf.getamount")
      ?.value || "";
  const tmpl_check_amount_new_std =
    tmpl_dt.find((item) => item.key_id === "key.asc.rereg.pcf.newstdgetamount")
      ?.value || "0";

  const max_pcf = tmpl_max_credit;
  const ori_pcf_revisi = [...originPCFRev];
  const [totalRemoved, setTotalRemoved] = useState(0);
  const [totalAdd, setTotalAdd] = useState(0);
  const [listData, setListData] = useState(mypcf);

  useEffect(() => {
    //const fetchAllPCF = compareArrays(fPCF, mypcf);
    setListData(mypcf);
  }, [mypcf]);

  const ResultData = useMemo(() => {
    let computedData = [...listData];

    computedData.sort((a, b) =>
      a.detail.coursetitle > b.detail.coursetitle ? 1 : -1,
    );

    const removedItems = computedData.filter(
      (item) => item.action_type === "remove",
    );
    setTotalRemoved(removedItems.length);
    const courseAdd = computedData.filter((item) => item.action_type === "add");
    setTotalAdd(courseAdd?.length || 0);

    const objSubjectUniq = computedData.reduce((accumulator, currentValue) => {
      if (
        currentValue.action_type === "add" &&
        currentValue.detail &&
        currentValue.detail.hasOwnProperty("not_billed") &&
        currentValue.detail.not_billed === 0
      ) {
        const {
          course_id,
          detail: { course_credit },
        } = currentValue;
        if (!accumulator.hasOwnProperty(course_id)) {
          accumulator[course_id] = course_credit;
        } else if (accumulator[course_id] !== course_credit) {
          accumulator[course_id] += course_credit;
        }
      }
      return accumulator;
    }, {});

    let tsks = 0;
    if (objSubjectUniq) {
      Object.keys(objSubjectUniq).map((k) => {
        tsks = tsks + objSubjectUniq[k];
      });
    }
    setTotalSKS(tsks);

    return computedData;
  }, [listData, setTotalSKS]);

  const handlerChangePCF = (data) => {
    const cloneData = [...listData];
    if (data.origin === true) {
      const updatedListData = cloneData.map((item) => {
        if (item.section_id === data.section_id) {
          item.action_type = "remove";
        }
        return item;
      });
      setMypcf(updatedListData);
      setListData(updatedListData);
    } else {
      const updatedListData = cloneData.filter(
        (prev) => prev.section_id !== data.section_id,
      );
      setMypcf(updatedListData);
      setListData(updatedListData);
    }
  };

  const ListRemoveItem = ({ data }) => {
    const listRemoveCourse = data.filter(
      (item) => item.action_type === "remove",
    );
    const handlerRedoPCF = (value) => {
      setListData((prevListData) => {
        const cloneData = [...prevListData];
        return cloneData.map((item) => {
          if (item.section_id === value.section_id) {
            item.action_type = "add";
            item.origin = "redo";
          }
          return item;
        });
      });
      openModal({ open: false });
    };
    return (
      <div className="hist-pcf">
        {Object.values(listRemoveCourse).length > 0 ? (
          listRemoveCourse.map((v, index) => (
            <div className="border p-3 rounded mb-8 shadow" key={index}>
              <div className="d-flex justify-content-start align-items-start">
                <div className="my-course w-100 ">
                  <span className="font-weight-bolder mb-1">
                    {v.detail.coursetitle}
                  </span>
                  <div>
                    <span className="text-muted font-weight-bold">
                      {v.detail.course_code
                        ? v.detail.course_code
                        : v.detail.code}
                    </span>
                  </div>
                </div>
                <div className="info-course mx-2 mx-xxl-5">
                  <span className="font-weight-bolder d-block">
                    Credit
                    <span className="ml-2 text-dark font-weight-bold">
                      {v.detail.course_credit}
                    </span>
                  </span>
                  <span className="text-muted text-capitalize">
                    {v.detail.course_type}
                  </span>
                </div>
                <button
                  className="btn btn-sm btn-icon btn-warning p-5"
                  type="button"
                  title={
                    student
                      ? "Restore to " + student.firstname + "'s PCF"
                      : "Redo the course"
                  }
                  onClick={() => handlerRedoPCF(v)}
                >
                  <i className="fas fa-redo"></i>
                </button>
              </div>
              <div className="cost_owner mt-5">
                <span className="font-weight-bolder d-block">
                  {v.detail.section_id ? v.detail.section_id : "-"}
                </span>
                <span className="font-weight-bolder text-muted">
                  Section ID
                </span>
              </div>
            </div>
          ))
        ) : (
          <p className="text-danger">No record found</p>
        )}
      </div>
    );
  };

  const PreviewPCF = () => {
    if (totalsks > max_pcf) {
      openToast({
        header: "Information",
        message: "The maximum total credit is " + max_pcf + " SKS",
      });
    } else {
      var cloneCourse = [...listData];
      var courses = cloneCourse.map((item) => {
        var obj = {};
        obj.action_type = item.action_type;
        obj.course_id = item.course_id;
        obj.section_id = item.section_id;
        return obj;
      });

      if (
        (stdStatus.term_intake.id === selectedAcad && tmpl_check_amount_new_std === "0") ||
        (tmpl_check_amount && tmpl_check_amount === "0")
      ) {
        openModal({
          header: "",
          message: (
            <PreviewPCFRevision
              myprev={[]}
              originPCFRev={ori_pcf_revisi}
              data={listData}
              studentid={studentid}
              fpcf={fPCF}
              finish={false}
              eventid={eventid}
              student={student}
            />
          ),
          size: "xl",
        });
      } else {
        GET_PCF_AMOUNT(courses);
      }
    }
  };

  const [pcfAmount, setPCFAmount] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const GET_PCF_AMOUNT = (courses) => {
    setPCFAmount({ loading: true, data: [], message: "" });
    var keys = {
      AppId: AuthDecode.AppID,
      AppEnv: AuthDecode.AppEnv,
      Secretkey: AuthDecode.secretkey,
    };

    var param = {
      courses: courses,
      studentid: studentid,
      term_id: acad.id,
    };

    var body = {
      parameters: param,
      target_data: "GET_PCF_AMOUNT",
    };

    const postData = {
      keys: keys,
      body: body,
    };

    AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
      if ("message" in response.response) {
        setPCFAmount({
          loading: false,
          data: [],
          message: response.response.message.user,
        });
        openToast({ header: "Error", message: response.response.message.user });
      } else {
        var result = response.response.result;
        if (result === "success") {
          var dataResult = response.response.data;
          setPCFAmount({ loading: false, data: dataResult, message: "" });
          openModal({
            header: "Preview PCF " + (student ? student.fullname : "") + " ",
            message: (
              <PreviewPCFRevision
                myprev={dataResult}
                originPCFRev={ori_pcf_revisi}
                data={listData}
                studentid={studentid}
                fpcf={fPCF}
                finish={false}
                eventid={eventid}
                student={student}
              />
            ),
            size: "xl",
          });
        } else {
          setPCFAmount({
            loading: false,
            data: [],
            message: "Failed preview PCF." + response.response.msg,
          });
          openToast({
            header: "Error",
            message: "Failed preview PCF." + response.response.msg,
          });
        }
      }
    });
  };

  return (
    <div className="card card-custom card-stretch gutter-b">
      <HeaderCardStd student={student} acad={acad} totalsks={totalsks} />

      <div
        className="card-body pt-0 px-0"
        style={{ maxHeight: "700px", overflowY: "auto" }}
      >
        <div className="table-responsive">
          <table className="table table-borderless table-vertical-center">
            <thead>
              <tr className="bg-light">
                <th>
                  <span className="text-dark">
                    COURSE ({totalAdd})
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {ResultData.length > 0 ? (
                ResultData.map((v, index) =>
                  !v.action_type || v.action_type === "add" ? (
                    <tr key={index}>
                      <td>
                        <div
                          className={
                            "border p-3 rounded " + (!v.origin && "bg-light")
                          }
                        >
                          <div className="d-flex justify-content-start align-items-start">
                            <div className="my-course w-100 ">
                              <span className="font-weight-bolder mb-1">
                                {v.detail.coursetitle}
                              </span>
                              <div>
                                <span className="text-muted font-weight-bold">
                                  {v.detail.course_code
                                    ? v.detail.course_code
                                    : v.detail.code}
                                </span>
                              </div>
                            </div>
                            <div className="info-course mx-2 mx-xxl-5">
                              <span className="font-weight-bolder d-block">
                                Credit
                                <span className="ml-2 text-dark font-weight-bold">
                                  {v.detail.course_credit}
                                </span>
                              </span>
                            </div>
                            <button
                              className="btn btn-sm btn-icon btn-danger p-5"
                              type="button"
                              title={
                                student
                                  ? "Remove from " +
                                  student.firstname +
                                  "'s PCF"
                                  : "Remove the course"
                              }
                              onClick={() => handlerChangePCF(v)}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                          <span className="font-weight-bolder d-block">
                            {v.detail.section_id ? v.detail.section_id : "-"}{" "}
                            /{v.detail?.section_name || ""}
                          </span>
                          <span className="font-weight-bolder text-muted">
                            Section ID / Name
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    ""
                  ),
                )
              ) : (
                <tr>
                  <td colSpan={2}>No record found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card-footer">
        <div className="d-flex justify-content-between align-items-center">
          <span className="font-weight-bolder">
            Total credit: {totalsks} SKS{" "}
          </span>
          <div className="btn-group d-none">
            <button className="btn btn-sm btn-icon btn-warning" type="button">
              <i className="fa fa-trash text-dark"></i>
            </button>
            <button
              className="btn btn-sm btn-light-warning btn-hover-light-warning"
              type="button"
              onClick={() =>
                openModal({
                  header: "Removed Course List",
                  message: <ListRemoveItem data={listData} />,
                })
              }
            >
              <span className="font-weight-bolder text-dark text-uppercase">
                {totalRemoved} course removed
              </span>
            </button>
          </div>
        </div>
        <div className="text-center">
          <button
            className="btn btn-lg btn-primary btn-block font-weight-bolder text-uppercase px-9 py-4"
            title="Preview and Approve"
            onClick={() =>
              PreviewTimetableNApprove(
                PreviewPCF,
                mypcf,
                acad?.id || 0,
                student,
              )
            }
            disabled={pcfAmount.loading}
          >
            {pcfAmount.loading ? "Processing..." : "Next and Preview"}
          </button>
        </div>
      </div>
    </div>
  );
}

const PreviewTimetableNApprove = (PreviewPCF, courses, termid, student) => {
  const RenderTimetable = () => {
    const [loading, setLoading] = useState(false);
    const [has_conflict, setHasConflict] = useState(false);
    const [prev_amount, setPrevAmmount] = useState(false);

    const handleNextAndApprove = () => {
      setPrevAmmount(true);
      PreviewPCF();
    };

    return (
      <div>
        <PreviewTimetables
          courses={courses}
          termid={termid}
          setLoading={setLoading}
          has_conflict={has_conflict}
          setHasConflict={setHasConflict}
        />
        {/* {has_conflict ? (
          <div className="alert alert-warning">
            <div className="alert-title text-left">
              <span className="font-weight-bold d-block font-size-lg text-dark">
                <i className="icon-1x text-dark flaticon-warning-sign mr-2"></i>
                Unable to Approve PCF
              </span>
              <span className="font-size-lg text-dark">
                Approval cannot be completed because there are unresolved time
                conflicts.
              </span>
            </div>
          </div>
        ) : ( */}
        {loading && (
          <div className="text-right">
            <button
              className="btn btn-lg btn-primary text-uppercase"
              type="button"
              onClick={handleNextAndApprove}
              disabled={prev_amount}
            >
              {prev_amount ? "Processing..." : "Next and Approve"}
            </button>
          </div>
        )}
        {/* )} */}
      </div>
    );
  };

  openModal({
    header: `${student?.firstname}'s Class schedule draft`,
    message: <RenderTimetable />,
    size: "xl",
  });
};

const compareArrays = (arrayA, arrayB) => {
  const outputArray = [];

  console.log(arrayA);
  console.log(arrayB);
  // Iterate through arrayA
  arrayA.forEach((itemA) => {
    // Check if itemA exists in arrayB
    const matchingItemB = arrayB.find(
      (itemB) => itemA.section_id === itemB.section_id,
    );

    if (matchingItemB) {
      // If itemA exists in arrayB, compare the 'status' property
      if (itemA.action_type !== matchingItemB.action_type) {
        // If 'status' is different, add it to outputArray
        outputArray.push({ ...itemA, action_type: matchingItemB.action_type });
      }
    } else {
      // If itemA does not exist in arrayB, add it to outputArray
      outputArray.push({ ...itemA, action_type: "add" });
    }
  });

  // Iterate through arrayB to find items not in arrayA
  arrayB.forEach((itemB) => {
    const matchingItemA = arrayA.find(
      (itemA) => itemB.section_id === itemA.section_id,
    );

    if (!matchingItemA) {
      // If itemB does not exist in arrayA, add it to outputArray
      let type = "";
      if (itemB.detail.action_type) {
        let typeArr = itemB.detail.action_type.split(".");
        type = typeArr[typeArr.length - 1];
      } else {
        type = itemB.action_type ? itemB.action_type : "add";
      }
      outputArray.push({ ...itemB, action_type: type });
    }
  });

  return outputArray;
};

const HeaderCardStd = ({ student, acad }) => {
  return (
    <div className="card-header align-items-center border-0 mt-4">
      <h3 className="card-title align-items-start flex-column">
        <span className="font-weight-bolder text-dark">
          {student ? student.firstname + "'s PCF Revision" : "UNKNOW STUDENT"}
        </span>
        <span className="text-muted mt-3 font-weight-bold font-size-sm">
          Periode {acad ? (acad.name ? acad.name : "-") : "-"}
        </span>
      </h3>
    </div>
  );
};
